import { request } from '@/utils/ajax';

export type MacGyverAccessLevel = 'None' | 'Standard' | 'Advanced' | 'Admin';

const accessLevelOrder: MacGyverAccessLevel[] = ['None', 'Standard', 'Advanced', 'Admin'];

/** Ordinal check: higher levels include the ones below (mirrors the backend policies). */
export function hasAccessLevel(actual: MacGyverAccessLevel, required: MacGyverAccessLevel) {
    return accessLevelOrder.indexOf(actual) >= accessLevelOrder.indexOf(required);
}

export interface UserInfoResponse {
    email: string;
    firstName: string;
    lastName: string;
    isLoggedIn: boolean;
    accessLevel: MacGyverAccessLevel;
}

export function getCurrentUser(): Promise<UserInfoResponse> {
    return request('api/auth/current-user').then((x) => x.json());
}

export function logout(): Promise<Response> {
    return request('api/auth/logout', { method: 'POST' });
}

export function getLoginUrl(returnUrl: string) {
    const relativePath = `api/auth/login/external?returnUrl=${encodeURIComponent(returnUrl)}`;
    if (window.location.host.startsWith('localhost')) {
        return 'https://localhost:44333/' + relativePath;
    }

    return relativePath;
}